import { render } from "./finalizeList.vue?vue&type=template&id=304b1952&scoped=true"
import script from "./finalizeList.vue?vue&type=script&lang=js"
export * from "./finalizeList.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304b1952"]])

export default __exports__